import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = [
  {
    label: 'S.N',
    value: 'S.N',
  },

  {
    label: 'Date',
    value: 'actualSupplyDate',
  },
  {
    label: 'Batch id',
    value: 'materialInwardBatchId',
  },
  {
    label: 'Supply hub',
    // value: 'pickupInfo[name]',
    value: 'pickupPointName',
  },
  /*  {
    label: 'Franchise',
    value: '-',
  },
  {
    label: 'Address',
    value: 'pickup_address',
  }, */
  {
    label: 'Category',
    value: 'categoryNameCollectOrder',
  },
  /* {
    label: 'Icon',
    value: 'categoryIcon',
  }, */
  // {
  //   label: 'Item',
  //   value: 'pickup_quantity_item',
  // },
  {
    label: 'Quantity',
    value: 'quantityDeposit_remark',
  },
  {
    label: 'Receive hub',
    // value: 'pickupInfo[centreName]',
    value: 'pickupInfoCn',
  },
  {
    label: 'Date',
    value: 'completedAt',
  },
  {
    label: 'Status',
    value: 'status',
  },
  // {
  //   label: 'certificate_view',
  // },
  // {
  //   action: ['qr'],
  // },
  {
    action: [''],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
